<template>
    <div
    >
        <v-alert
            color  = "error"
            v-if   = "errortext"
            class  = "pa-2 white--text mr-3"
            v-html = "errortext"
        />

        <v-container
            v-if   = "hasFaults"
            class  = "fault-panel"
            :style = "'max-height:' + height + 'px; height:' + h + 'px'"
        >
            <div
                v-for="(item, index) in faults"
                :key="index"
            >
                <div class="v-flex " :class="index < faults.length - 1 ? 'mb-4' : ''">
                    <div>
                        <v-checkbox
                            v-if="needsCommitment(item)"
                            v-model="item.confirmed"
                            style         = "margin-left: 2px; margin-top: -4px"
                            class         = "mt-0"
                            background-color="white"
                            :hide-details = true
                            :ripple       = false
                        />

                        <div
                            class="fault-rating"
                            :class="color(item)"
                            @contextmenu="show"
                            :data-index="index"
                            :style="needsCommitment( item) ? 'height: 110px;' : 'height: 138px;'"
                        >
                            {{ ratingName(item.rating) }}
                        </div>
                    </div>

                    <v-menu
                        v-model="showMFaultMenu"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                    >
                        <v-list>
                            <v-list-item link @click="onCopy(item.description)">
                                <v-list-item-title>Text kopieren</v-list-item-title>
                            </v-list-item>
                            <v-divider class="mt-2 mb-2" />
                            <v-list-item
                                v-for = "(rating, index) in items"
                                class = "pl-0"
                                :key  = "index"
                                @click = "onChangeType (item, rating)"
                                link
                            >
                                <v-list-item-title
                                    class="pl-2"
                                >
                                    <v-icon color="black" size="20">mdi-chevron-right</v-icon> {{ rating.name }}
                                </v-list-item-title>
                            </v-list-item>
                            <v-divider class="mt-2 mb-2" />
                            <v-list-item link @click="onDelete(item)">
                                <v-list-item-title class="red--text v-flex">
                                    <v-icon color="red" size="22">mdi-delete</v-icon>
                                    <div style="margin-top: 2px">Löschen</div>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-textarea
                        v-model        = "item.description"
                        rows           = "6"
                        class          = "mt-0 pt-0 pr-1"
                        ref            = "description"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        :readonly      = "readonly"
                        :disabled      = "readonly"
                        no-resize
                        hide-details
                    />
                </div>
            </div>
        </v-container>
        <div class="mt-0 v-flex" style="justify-content: space-between" v-if="!readonly">
            <v-menu
                v-model="showMenu"
                absolute
                offset-y
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        class  = "pt-1"
                    >
                        <i class="fas fa-plus"></i>
                        <span class="ml-2">{{ $t('inc.assessment.addFault') }}</span>
                    </div>
                </template>

                <v-list>
                    <v-list-item
                        v-for  = "(item, index) in items"
                        :key   = "index"
                        @click = "onAdd(item)"
                    >
                        <v-list-item-title >{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

    </div>
</template>

<script>

import Assessment from "@/modules/inc/assessments/service/Assessment";
import Core from "@/modules/core/service/Core";

export default {
    name: "IncAssessmentFaults",

    components: {
    },

    props: {
        faults: {
            required: false,
            type    : Array,
            default : function () {
                return [];
            }
        },

        result: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        height: {
            required: true,
            type    : Number
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        drag        : false,
        showMenu    : false,
        showMFaultMenu: false,
        x: 0,
        y: 0,
        trash       : [],
        errortext   : null,
        ratings     : Assessment.ratings,
        h           : null,
        selected    : null
    }),

    computed: {
        items () {
            return this.$store.getters.inc.assessmentfaulttypes;
        },

        needFaultValidation () {
            return this.result && (
                this.result.id === 'DANGER'
                || this.result.id === 'MAJOR'
                || this.result.id === 'MINOR'
                || this.result.id === 'VALID'
            );
        },

        hasFaults () {
            if (this.faults) {
                return this.faults.length > 0;
            }

            return false;
        },
    },

    watch: {
        result: {
            deep: true,
            handler: function () {
                if (this.result) {
                    this.validateFaults();
                }
            }
        },

        faults () {
            this.validateFaults();
        }
    },

    mounted() {
        this.validateFaults();
    },

    methods: {
/*
        onInsert(event) {
            this.faults.splice(event.index, 0, event.data);
            this.h = this.faults.length * (138 + 16);
        },
*/

        onRemove (item) {
            const index = this.faults.findIndex (fault => fault.no === item.no);
            this.faults.splice(index, 1);
            this.validateFaults();
        },

        onChangeType (item, rating) {
            if (!this.selected) {
                return;
            }

            this.selected.rating = rating;
        },

        onConfirmend (item, value) {
            console.log("confirm", item, value)
            this.$nextTick(() =>{
                item.confirmed = value
            } )
        },

        color (fault) {
            if (!fault.rating) {
                return "primary";
            }

            return Assessment.ratings[fault.rating.id].color;
        },

        onAdd (rating) {
            if (this.faults === null) {
                this.faults = [];
            }

            this.faults.push({
                rating: rating,
                description: ""
            })

            this.validateFaults();
        },

        ratingName (rating) {
            if (!rating) {
                return "";
            }

            return Assessment.ratingName (rating);
        },


        needsCommitment (item) {
            return item.rating && item.rating.id !== "NOTICE";
        },

        validateFaults () {
            this.h = this.faults.length * (138 + 16) - 10;
            if (!this.needFaultValidation) {
                this.errortext = null;
                return null;
            }

            let max = null;
            this.faults.filter(f => f.rating).forEach(f => {
                if (!max || this.compareRating(max, f.rating) > 0) {
                    max = f.rating;
                }
            });

            if (max != null) {
                const result = this.compareRating(this.result, max);
                if (result > 0) {
                    this.errortext = this.$t("inc.assessment.error.faultsMax", [ this.result.name, max.name ]);
                    return;
                } else  if (result < 0) {
                    if (max.id === 'NOTICE') {
                        this.errortext = this.$t("inc.assessment.error.faultsNotice", [ this.result.name, max.name ]);
                    } else {
                        this.errortext = this.$t("inc.assessment.error.faultsMin", [ this.result.name, max.name ]);
                    }
                    return;
                }
            }

            this.errortext = null;
        },

        compareRating (left,right) {
            const rankLeft  = this.ratings[left.id].rank;
            const rankRight = this.ratings[right.id].rank;
            return rankLeft - rankRight;
        },

        show (e) {
            e.preventDefault()
            const el = e.target;
            this.selected = null;
            if (el && el.dataset.index) {
                this.selected = this.faults[el.dataset.index];
            }

            this.showMFaultMenu = false
            this.x = e.clientX
            this.y = e.clientY
            this.$nextTick(() => {
                this.showMFaultMenu = true
            })
        },

        onCopy () {
            if (!this.selected) {
                return;
            }

            const text = this.selected.description;
            navigator.clipboard.writeText(text);
            Core.message.hint(this, text + " wurde ins Clipboard kopiert!")
        },

        onDelete (fault) {
            console.log("delete", fault, this.faults)
            const index = fault.id ? this.faults.findIndex(f => f.id = fault.id) : this.faults.findIndex(f => f.no = fault.no);
            if (index >= 0) {
                this.faults.splice (index, 1);
                this.$emit ("change", this.faults)
            }
        }
    }
}
</script>

<style scoped>

.fault-panel {
    display: inline-block;
    padding: 0!important;
    width: 100%;
    overflow-y: scroll;
    padding-right: 2px;
}

.fault-rating {
    width: 25px;
    color: white;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    text-orientation: sideways;
    font-size: 15px;
    text-align: center;
    padding-left: 3px;
    padding-top: 5px;
    margin-right: 3px;
    padding-bottom: 10px;
    border-radius: 4px;
    cursor: move;
}

.trash {
    width: 55px;
    padding-left: 20px;
    height: 36px;
    padding-top: 6px;
    margin-top: -6px;
    border-radius: 5px;
}

.trash i {
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 20px;
}

</style>


